import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface SkeletonCellProps {
  flex?: number
}

interface TableWrapperProps {
  dropTargetRowId?: string | null
}

export const TableWrapper = styled.div<TableWrapperProps>`
  header {
    margin-inline: 0;
    border-top: none;
    border-right: none;
    border-left: none;
  }

  ${({ dropTargetRowId }) =>
    dropTargetRowId &&
    `
      [data-row-id="${dropTargetRowId}"] {
        border: 2px dashed ${Color.Grey300};
        border-radius: ${BorderRadius.R8};
        background-color: ${Color.Grey50};
      }
    `}
`
export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  padding: ${Spacing.S12} 0;
  border-bottom: 1px solid ${Color.Grey200};
`
export const SkeletonCell = styled.div<SkeletonCellProps>`
  display: flex;
  align-items: center;
  flex: ${({ flex }) => flex};
  gap: ${Spacing.S8};
`

export const DocumentStaticActionsWrapper = styled.div``
